import { Component } from '@angular/core';
import { DotComponent } from '../dot/dot.component';

@Component({
  selector: 'app-legends',
  imports: [DotComponent],
  templateUrl: './legends.component.html',
  styleUrl: './legends.component.css',
  host: { class: 'floating-box' },
})
export class LegendsComponent {}
